/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useRef, useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axios from 'axios';
import Callicon from '../../Icon/call.svg';
import Lockicon from '../../Icon/lock.svg';
import Eyeicon from '../../Icon/eye.svg';
import Eyeslashicon from '../../Icon/eye-slash.svg';
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db, requestForToken } from '../../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const Login = () => {

    const { t } = useTranslation();
    const { BaseUrl, setIsLoginShow, setIsSignUpShow, setIsLogin } = useContext(MyContext);

    const [value, setValue] = useState();
    const [password, setPassowrd] = useState("");
    const [passType, setPassType] = useState("Password");
    const [passType2, setPassType2] = useState("Password");
    const [passType3, setPassType3] = useState("Password");
    const [isPageShow, setIsPageShow] = useState("Login");
    const [forgot, setForgot] = useState("");
    const [sendOtp, setSendOtp] = useState("");
    const [otpBox, setOtpBox] = useState(Array(6).fill(''));
    const [newPassword, setNewPassword] = useState({ passowrd: "", confirm: "" });

    const InputRef = useRef();
    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const navoigate = useNavigate();

    const handleLogin = () => {

        if (!value && !password) {
            showTost(t("Please Enter Details !!"), "error");
            return;
        }

        if (password.length < 3) {
            showTost(t("Password must be at least 3 characters long!!"), "error");
            return;
        }

        const formattedPhoneNumber = formatPhoneNumberIntl(value);
        const countryCallingCode = formattedPhoneNumber.split(' ')[0];
        const mobileNumber = formattedPhoneNumber.replace(countryCallingCode, '').trim();
        const joinNumber = mobileNumber.split(' ').join('');

        const Data = {
            mobile: joinNumber,
            ccode: countryCallingCode,
            password: password
        };

        axios.post(`${BaseUrl}user_api/u_login_user.php`, Data)
            .then((res) => {
                // console.log("u_login_user.php", res);
                const { ResponseMsg, ResponseCode, UserLogin } = res.data;

                const toastType = ResponseCode === '200' ? 'success' : 'error';
                showTost(ResponseMsg, toastType);

                if (ResponseCode === "200") {
                    secureLocalStorage.setItem("LoginData", JSON.stringify(UserLogin));
                    secureLocalStorage.setItem("Wallet", UserLogin.wallet);
                    HandleFirebase(UserLogin);
                    secureLocalStorage.setItem("Userid", UserLogin.id);
                    setIsLogin("123");
                    setIsLoginShow(false);
                    navoigate("/");
                }

            })
            .catch((error) => {
                console.error(error);
            });

    };

    const HandleContinue = () => {

        if (!forgot) {
            showTost(t("Please enter number"), "error");
            return;
        }


        const formattedNumber = formatPhoneNumberIntl(forgot);
        const countryCode = formattedNumber.split(' ')[0];
        const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
        const cleanedNumber = numberWithoutCode.split(' ').join('');

        const Data = {
            mobile: cleanedNumber,
            ccode: countryCode,
        };

        axios.post(`${BaseUrl}user_api/mobile_check.php`, Data)
            .then((res) => {
                // console.log("mobile_check.php", res);
                const { ResponseCode, ResponseMsg } = res.data;
                if (ResponseCode !== "200") {
                    axios.get(`${BaseUrl}user_api/sms_type.php`)
                        .then((res) => {
                            // console.log("sms_type", res);
                            const { ResponseCode, SMS_TYPE, otp_auth } = res.data;
                            if (ResponseCode === "200") {
                                if (otp_auth === "Yes") {
                                    if (SMS_TYPE === "Msg91") {
                                        handleMSG91(Data);
                                    } else if (SMS_TYPE === "Twilio") {
                                        handleTwilio(Data);
                                    }
                                }
                            }
                        });
                } else {
                    showTost(ResponseMsg, "error");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleMSG91 = (data) => {
        axios.post(`${BaseUrl}user_api/msg_otp.php`, data)
            .then((res) => {
                // console.log("msg91", res);
                const { ResponseCode, otp } = res.data;
                if (ResponseCode === "200") {
                    showTost(t("OTP send successfully !!"), "success");
                    setIsPageShow("OTP");
                    setSendOtp(otp);
                }
            });
    };

    const handleTwilio = (data) => {
        axios.post(`${BaseUrl}user_api/twilio_otp.php`, data)
            .then((res) => {
                // console.log("twilio", res);
                const { ResponseCode, otp } = res.data;
                if (ResponseCode === "200") {
                    showTost(t("OTP send successfully !!"), "success");
                    setIsPageShow("OTP");
                    setSendOtp(otp);
                }
            });
    };

    const HandleChange = (index, value) => {
        const OTP = [...otpBox];
        OTP[index] = value;
        setOtpBox(OTP);
        if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    };

    const HandleKeyPress = (index, e) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    }
        ;
    const HandleVerifyOTP = () => {
        if (sendOtp === Number(otpBox.join(""))) {
            setIsPageShow("NewPass");
        } else {
            showTost(t("OTP is invalid !!"), "error");
        }
    };

    const HandleResetPass = () => {

        if (!newPassword.passowrd && !newPassword.confirm) {
            showTost("Enter Password !!", "error");
            return;
        }

        if (newPassword.passowrd === newPassword.confirm) {

            const formattedNumber = formatPhoneNumberIntl(forgot);
            const countryCode = formattedNumber.split(' ')[0];
            const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
            const cleanedNumber = numberWithoutCode.split(' ').join('');

            const Data = {
                mobile: cleanedNumber,
                ccode: countryCode,
                password: newPassword.confirm
            };

            axios.post(`${BaseUrl}user_api/u_forget_password.php`, Data)
                .then((res) => {
                    const { ResponseCode, ResponseMsg } = res.data;
                    // console.log("forgot_password", res);
                    const TostType = ResponseCode === "200" ? "success" : "error";
                    showTost(ResponseMsg, TostType);
                    setIsLoginShow(false);
                })
                .catch((error) => {
                    console.error("forgot_password", error);
                });

        } else {
            showTost(t("Not Match Password !!"), "error");
        }
    };

    const HandleFirebase = async (Data) => {

        const token = await requestForToken();
        const userRef = doc(db, "MagicUser", Data.id);

        getDoc(userRef)
            .then((docSnapshot) => {
                if (!docSnapshot.exists() && token) {
                    const number = Data?.ccode + Data?.mobile;

                    setDoc(userRef, {
                        email: Data?.email,
                        isOnline: false,
                        lastActive: new Date(),
                        name: Data?.name,
                        number,
                        pro_pic: Data?.pro_pic,
                        token: token,
                        uid: Data?.id
                    })
                        .then(() => {
                            // console.log('User Add in Firebase..!!');
                        });
                }
            });
    };

    return (
        <div>
            {isPageShow === "Login" && <div className="py-[10px] px-[20px] login-box">
                <h1 className='text-[22px] font-bold'>{t("Sign in to MagicMate")}</h1>
                <span className="text-gray-500 text-[16px] font-[500]">{t("welcome back Please enter your details.")}</span>
                <div className="relative gap-[5px] login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
                    <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                    <PhoneInput
                        className="w-[100%]"
                        ref={InputRef}
                        international
                        defaultCountry="IN"
                        value={value}
                        onChange={setValue}
                        name="phone"
                        style={{ outline: "none" }}
                    />
                    {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>{t("Phone Number")}</h1>}
                </div>
                <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="Lockicon" className="w-[25px]" />
                    <input onChange={(e) => setPassowrd(e.target.value)} className="bg-transparent px-[10px] w-[100%] outline-none" type={passType} placeholder={t("Passowrd")} />
                    <img onClick={() => passType === "text" ? setPassType("Password") : setPassType("text")} src={passType === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>
                <button onClick={() => setIsPageShow("Forgot")} className='mt-[10px] font-bold text-gray-600'>{t("Forgot passowrd?")} <span className='text-[#0000ffb7]'>{t("Reset it")}</span></button>
                <button onClick={handleLogin} className="button">{t("Sign In")}</button>
                <h1 className="mt-[10px] text-center font-bold text-gray-600">{t("Don't have and account?")} <button onClick={() => { setIsLoginShow(false); setIsSignUpShow(true); }} className="text-[#534cfe] cursor-pointer">{t("Sign Up")}</button> </h1>
            </div>}

            {isPageShow === "Forgot" && <div className="py-[10px] px-[20px]">
                <h1 className='text-center text-[24px] font-[600]'>{t("Can't Sign in?")}</h1>
                <p className='text-center text-gray-500 text-[17px] leading-[25px]'>{t("Enter the mobile number associated with you account, and Magicmate will send you OTP to your register mobile number")}</p>
                <div className="relative login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
                    <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                    <PhoneInput
                        className="w-[100%]"
                        ref={InputRef}
                        international
                        defaultCountry="IN"
                        value={forgot}
                        onChange={setForgot}
                        name="phone"
                        style={{ outline: "none" }}
                    />

                    {!forgot && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>{t("Phone Number")}</h1>}

                </div>

                <button onClick={HandleContinue} className='button'>{t("Continue")}</button>
                <button onClick={() => setIsPageShow("Login")} className="w-[100%] border-[1px] border-[#0000ffb7] font-[600] py-[8px] mt-[10px] text-[#0000ffc4] rounded-[10px]">{t("Return to Sign In")}</button>
            </div>}

            {isPageShow === "OTP" && <div className="py-[10px] px-[20px] signup-box">
                <h1 className='font-[600] text-[20px]'>{t("Awesome")}</h1>
                <p>{t("We have send the OTP to")} {forgot}</p>
                <h1>{t("Your OTP")} :- {sendOtp}</h1>
                <div className="flex items-center gap-[20px] mt-[10px]">
                    {otpBox.map((value, index) => {
                        return <input
                            ref={(e) => (OtpRef.current[index] = e)}
                            key={index}
                            value={value}
                            className='otp-box focus-within:outline-[#0000ffb7]'
                            type="text"
                            maxLength="1"
                            onKeyDown={(e) => HandleKeyPress(index, e)}
                            onChange={(e) => HandleChange(index, e.target.value)}
                            inputMode="numeric"
                        />
                    })}
                </div>
                <button onClick={HandleVerifyOTP} className='button'>{t("VERIFY OTP")}</button>
            </div>}

            {isPageShow === "NewPass" && <div className="py-[10px] px-[20px]">
                <h1 className='font-[600] text-[18px] text-center'>{t("Create A New Password")}</h1>
                <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, passowrd: e.target.value })} type={passType2} placeholder={t('Passowrd')} className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => passType2 === "text" ? setPassType2("Password") : setPassType2("text")} src={passType2 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>
                <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, confirm: e.target.value })} type={passType3} placeholder={t('Confrim Password')} className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => passType3 === "text" ? setPassType3("Password") : setPassType3("text")} src={passType3 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>

                <button onClick={HandleResetPass} className='button'>{t("Continue")}</button>

            </div>}

        </div>
    )
}

export default Login
/* jshint ignore:end */